import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import Login from '../components/Login.vue'
import TodoList from '../subView/todolist/TodoList.vue'
import Abhs from '../subView/abhs/Abhs.vue'
import Gallery from '../subView/abhs/Gallery.vue'
import Practice from '../subView/abhs/Practice.vue'
import Memorization from '../subView/abhs/Memorization.vue'
import Edit from '../subView/abhs/Edit.vue'
// import Graph from '../subView/graph/Graph.vue'
import Graph from '../subView/graph/KnowledgeGraph.vue'
import Ranking from '../subView/ranking/Ranking.vue'
import FileManage from '../subView/fileManage/FileManage.vue'
import TimeTracker from '../subView/todolist/components/TimeTracker.vue'
import InfoGather from '../subView/infoGather/infoGather.vue'
import FutureEngine from '../subView/futureEngine/futureEngine.vue'
import HomeworkView from '../subView/futureEngine/HomeworkView.vue'
// 导入新增的admin页面
import Admin from '../subView/admin/index.vue'
import AuthService from '../services/authService'

// 定义路由标题映射
const routeTitles = {
    'MainView': '主控面板 - AJYYWEB',
    'Login': '用户登录 - AJYYWEB',
    'TodoList': '任务清单 - AJYYWEB',
    'Abhs': '快速抢答 - AJYYWEB',
    'GalleryE': '英语词库 - AJYYWEB',
    'GalleryC': '中文字词库 - AJYYWEB',
    'Practice': '练习模式 - AJYYWEB',
    'Memorization': '记忆模式 - AJYYWEB',
    'Edit': '编辑模式 - AJYYWEB',
    'GraphWeb': '知识图谱 - AJYYWEB',
    'FileManage': '文件管理 - AJYYWEB',
    'Ranking': '排行榜 - AJYYWEB',
    'TimeTracker': '时间追踪 - AJYYWEB',
    'InfoGather': '信息收集 - AJYYWEB',
    'FutureEngine': '未来引擎 - AJYYWEB',
    'HomeworkView': '我的作业 - AJYYWEB',
    'Admin': '数据管理后台 - AJYYWEB'
}

const routes = [
    {
        path: '/',
        name: 'MainView',
        component: MainView
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/todo',
        name: 'TodoList',
        component: TodoList
    },
    {
        path: '/abhs',
        name: 'Abhs',
        component: Abhs
    },
    {
        path: '/abhs/galleryE',
        name: 'GalleryE',
        component: Gallery
    },
    {
        path: '/abhs/galleryC',
        name: 'GalleryC',
        component: Gallery
    },
    {
        path: '/abhs/practice',
        name: 'Practice',
        component: Practice
    },
    {
        path: '/abhs/memorization',
        name: 'Memorization',
        component: Memorization
    },
    {
        path: '/abhs/edit',
        name: 'Edit',
        component: Edit
    },
    {
        path: '/graphWeb',
        name: 'GraphWeb',
        component: Graph
    },
    {
        path: '/filemanage',
        name: 'FileManage',
        component: FileManage
    },
    // 重定向规则，处理可能的旧路径引用
    {
        path: '/todolist',
        redirect: '/todo'
    },
    {
        path: '/ranking',
        name: 'Ranking',
        component: Ranking
    },
    {
        path: '/timetracker',
        name: 'TimeTracker',
        component: TimeTracker
    },
    {
        path: '/infogather',
        name: 'InfoGather',
        component: InfoGather
    },
    {
        path: '/futureengine',
        name: 'FutureEngine',
        component: FutureEngine
    },
    {
        path: '/homework',
        name: 'HomeworkView',
        component: HomeworkView
    },
    // 新增：admin页面路由
    {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: { requiresAuth: true, userType: 1 } // 添加元数据用于权限检查
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 全局路由守卫，用于设置页面标题和权限检查
router.beforeEach((to, from, next) => {
    // 设置页面标题
    const title = routeTitles[to.name] || 'AJYYWEB'
    document.title = title

    // 权限检查
    if (to.matched.some(record => record.meta?.requiresAuth)) {
        // 检查用户是否已登录
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            // 如果用户未登录，重定向到登录页
            next({ name: 'Login' });
            return;
        }

        // 使用与futureEngine一致的userType判断逻辑
        // 先尝试获取userType字段，如果不存在则尝试user_type字段
        const userType = currentUser.userType !== undefined ? currentUser.userType : (currentUser.user_type !== undefined ? currentUser.user_type : null);
        const finalUserType = (userType !== null) ? userType : 10; // 默认值为10

        // 检查是否为管理员 (usertype === 1)
        if (to.meta.userType && finalUserType !== to.meta.userType) {
            // 如果用户类型不是1，重定向到主页
            next({ name: 'MainView' });
            return;
        }
    }

    // 继续路由导航
    next()
})

export default router